import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EffectsModule } from '@ngrx/effects';
import { SharedModule } from 'libs/shared/src/lib/shared.module';
import { SpinnersModule } from '@cradua/spinners';
import { EpimsDashboardNavModule } from '@cradua/epims-dashboard-nav';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { AngularMaterialModule } from '@cradua/material';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Route } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { NgxPrintModule } from 'ngx-print';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { ProjectManagementRoutingModule } from './project-management-routing.module';
import { ProjectManagementContainerComponent } from './containers/project-management-container/project-management-container.component';
import { RegisterGmouComponent } from './components/register-gmou/register-gmou.component';
import * as fromProject from './states';
import { ProjectManagementEffects } from './states/+project-management/project-management.effects';
import { ProjectManagementFacade } from './states/+project-management/project-management.facade';
import { GmouEffects } from './states/+gmou/gmou.effects';
import { GmouFacade } from './states/+gmou/gmou.facade';
import { GmouContainerComponent } from './containers/gmou-container/gmou-container.component';
import { NewProjectComponent } from './components/new-project/new-project.component';
import { ProjectMonitoringComponent } from './components/project-monitoring/project-monitoring.component';
import { ProjectMonitorContainerComponent } from './containers/project-monitor-container/project-monitor-container.component';
import { ProjectProgressContainerComponent } from './containers/project-progress-container/project-progress-container.component';
import { ProjectProgressComponent } from './components/project-progress/project-progress.component';
import { ProjectReportContainerComponent } from './containers/project-report-container/project-report-container.component';
import { ProjectReportComponent } from './components/project-report/project-report.component';
import { ViewProjectsComponent } from './components/view-projects/view-projects.component';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { TruncateTextPipe } from './trucate.pipe';
import { ViewProjectActivitySummaryComponent } from './components/view-project-activity-summary/view-project-activity-summary.component';
import { ProjectActivityEffects } from './states/+project-activity/project-activity.effects';
import { ProjectStakeholderEffects } from './states/+project-stakeholder/project-stakeholder.effects';
import { ProjectPaymentEffects } from './states/+project-payment/project-payment.effects';
import { ProgressMasterEffects } from './states/+progress-master/progress-master.effects';
import { ProgressHistoryEffects } from './states/+progress-history/progress-history.effects';
import { ProgressMeetingEffects } from './states/+progress-meeting/progress-meeting.effects';
import { ProjectClusterEffects } from './states/+project-cluster/project-cluster.effects';
import { ProjectDocumentEffects } from './states/+project-document/project-document.effects';
import { ProjectActivityFacade } from './states/+project-activity/project-activity.facade';
import { ProjectStakeholderFacade } from './states/+project-stakeholder/project-stakeholder.facade';
import { ProjectClusterFacade } from './states/+project-cluster/project-cluster.facade';
import { ProjectPaymentFacade } from './states/+project-payment/project-payment.facade';
import { ProgressMasterFacade } from './states/+progress-master/progress-master.facade';
import { ProgressHistoryFacade } from './states/+progress-history/progress-history.facade';
import { ProgressMeetingFacade } from './states/+progress-meeting/progress-meeting.facade';
import { ProjectDocumentFacade } from './states/+project-document/project-document.facade';
import { ScholarshipInfoService } from 'libs/scholarship-management/src/lib/services/scholarshipinfo.service';
import { BudgetPerformanceContainerComponent } from './containers/budget-performance-container/budget-performance-container.component';
import { BudgetPerformanceComponent } from './components/budget-performance/budget-performance.component';
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    AngularMaterialModule,
    NgxMatSelectSearchModule,
    EpimsDashboardNavModule,
    ProjectManagementRoutingModule,
    HttpClientModule,
    SpinnersModule,
    Ng2SearchPipeModule,
    FormsModule,
    // BrowserAnimationsModule,
    SharedModule,
    NgxPrintModule,
    ReactiveFormsModule,
    StoreModule.forFeature(
      fromProject.ProjectManagementStoreReducer.PROJECT_MANAGEMENT_FEATURE_KEY,
      fromProject.ProjectManagementStoreReducer.reducer
    ),
    EffectsModule.forFeature([
      ProjectManagementEffects,
      GmouEffects,
      ProjectActivityEffects,
      ProjectStakeholderEffects,
      ProjectClusterEffects,
      ProjectPaymentEffects,
      ProgressMasterEffects,
      ProgressHistoryEffects,
      ProgressMeetingEffects,
      ProjectDocumentEffects,
    ]),
  ],
  providers: [
    ProjectManagementFacade,
    GmouFacade,
    ProjectActivityFacade,
    ProjectStakeholderFacade,
    ProjectClusterFacade,
    ProjectPaymentFacade,
    ProgressMasterFacade,
    ProgressHistoryFacade,
    ProgressMeetingFacade,
    ProjectDocumentFacade,
    ScholarshipInfoService,
  ],
  declarations: [
    ProjectManagementContainerComponent,
    RegisterGmouComponent,
    GmouContainerComponent,
    NewProjectComponent,
    ProjectMonitoringComponent,
    ProjectMonitorContainerComponent,
    ProjectProgressContainerComponent,
    ProjectProgressComponent,
    ProjectReportContainerComponent,
    ProjectReportComponent,
    ViewProjectsComponent,
    TruncateTextPipe,
    ViewProjectActivitySummaryComponent,
    BudgetPerformanceContainerComponent,
    BudgetPerformanceComponent,
  ],
})
export class ProjectManagementModule {}
